import React, { Component } from 'react'
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title'

const PartTemplatesWrapper = ({ children, route }) => {
  return (
    <DocumentTitle title={ route.title }>
      { children }
    </DocumentTitle>
  )
}
PartTemplatesWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  route: PropTypes.object.isRequired,
}

export default PartTemplatesWrapper
